import React from "react";

import { Stack } from "@mui/material";

import { useContentShareState } from "amazon-chime-sdk-component-library-react";

import { useGetMeetingJoinInfo } from "../../../../store";
import { MeetingInfoContext } from "../../../../context";

import ContentShareTile from "./components/content-share-tile";
import CornerLocalView from "./components/corner-local-view";
import LiveAnnotator from "../../../live-annotator";
import WebControlBar from "../../bars/web-control-bar/web-control-bar";
import { FilteredVideoTileGrid } from "../../video/tiles";
import { MeetingLayout } from "../../../../types";

interface WebLayoutProps {
  viewHeight: number;
  viewWidth: number;
  layout: MeetingLayout;
}

const WebLayout: React.FC<WebLayoutProps> = ({
  viewHeight,
  viewWidth,
  layout,
}: WebLayoutProps) => {

  const { tiles } = useContentShareState();

  const contentShare = tiles.length > 0

  const { userId, meetingId, joinCode } =
    React.useContext(MeetingInfoContext);

  const { showAnnotation } = React.useContext(MeetingInfoContext);

  const { data: userJoinInfo } = useGetMeetingJoinInfo(meetingId, userId, joinCode)

  return (
    <>
      <Stack
        id={"normal-meeting-stack"}
        justifyContent={"center"}
        justifyItems={"center"}
        alignContent={"center"}
        alignItems={"center"}
        minHeight={`${viewHeight}vh`}
      >
        {contentShare && (
          <ContentShareTile
            tileCount={1}
            viewHeight={viewHeight}
            viewWidth={viewWidth}
          />
        )}
        {!contentShare && !showAnnotation && (
          <FilteredVideoTileGrid
            viewHeight={viewHeight}
            viewWidth={viewWidth}
            showNamePlate
            excludeSelf={layout != "training"}
          />
        )}
        {userJoinInfo && (
          <LiveAnnotator
            joinInformation={userJoinInfo}
            viewHeight={viewHeight}
            viewWidth={viewWidth}
          />
        )}
      </Stack>
      <WebControlBar
        startWithVideo={layout === "remote"}
        contentShare={contentShare}
        layout={layout}
      />
      <CornerLocalView viewHeight={viewHeight} viewWidth={viewWidth} />
    </>
  );
};

export default WebLayout;
